import { useContext, useEffect, useState, useCallback } from "react";
import { Formik, Form } from "formik"
import * as Yup from 'yup';
import { EditableContext } from "common/EditableContextProvider";
import { Select, Button } from "antd";
import { ErrorMessage } from "formik";

export const FormComponent = () => {
    const { context } = useContext(EditableContext);
    const { FormBase } = context;
    const [isLoading, setIsLoading] = useState(false);
    const [initialValues, setInitialValues] = useState({});
    const defaultItem = {
        id: 0,
        name: "",
        messages: []
    }

    useEffect(() => {
        setInitialValues(getInitialValues());
        context.files.fill();
    }, [context.editID]);

    const getInitialValues = useCallback(
        () => {
            let it = context.getItemSelected();
            if (!it) { it = defaultItem; }
            else { it = { ...it }; }
            return it;
        }, [context.editID]);

    const validateSchema = Yup.object({
        name: Yup.string()
            .required('El campo es obligatorio'),
        messages: Yup.array()
            .min(1, 'La campaña debe tener al menos un mensaje.')
            .max(3, 'La campaña debe tener como máximo 3 mensajes.')
    });

    const handleSubmit = async (values, formik) => {
        try {
            setIsLoading(true);
            let id = await context.saveItem(values);
            if (id) {
                formik.setFieldValue('id', id);
                setInitialValues(prev => ({...prev, ...values, id: id}));
            } else { setInitialValues(prev => ({...prev, ...values})); }
        } catch (error) {
            const { errors } = error.response.data;
            let keys = Object.keys(errors);
            keys.forEach((key) => {
                formik.setFieldError(key, errors[key][0]);
            });
        }
        finally { setIsLoading(false); }
    }

    const addMessage = (formik, typeMessage) => {
        let messages = formik.values.messages ?? [];
        let d = new Date();
        messages.push({
            id: d.getMilliseconds(),
            type: typeMessage,
            value: ""
        });
        formik.setFieldValue('messages', messages);
    }

    const removeMessage = (formik, id) => {
        let messages = formik.values.messages ?? [];
        messages = messages.filter(msg => msg.id !== id);
        formik.setFieldValue('messages', messages);
    }

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validateSchema}
            enableReinitialize={true}
        >
            {
                (formik) => (
                    <Form>
                        <fieldset disabled={FormBase.isLoading}>
                            <div className="mb-2">
                                <FormBase.FormTextField formik={formik} label="Nombre de la campaña" id="name" required={true} />
                            </div>
                            <hr />

                            {/* Moona ASMR */}
                            {
                                formik.values.messages?.map((msg, i) => (
                                    <div key={msg.id} className="mb-2">
                                        {
                                            msg.type === 'text' && (
                                                <div className="position-relative">
                                                    <textarea className="form-control form-control-sm" name="" id=""
                                                        onChange={(e) => {
                                                            let c_msgs = formik.values.messages;
                                                            let c_msg = {...c_msgs[i], value: e.target.value};
                                                            c_msgs[i] = c_msg;
                                                            formik.setFieldValue('messages', c_msgs);
                                                        }}
                                                        value={msg.value ?? ""}
                                                    ></textarea>

                                                    <button type="button" className="btn btn-sm p-0 position-absolute mx-1 top-0"
                                                        style={{ right: "-18px" }}
                                                        onClick={() => removeMessage(formik, msg.id)}
                                                    >
                                                        <i className="fas fa-xmark text-danger"></i>
                                                    </button>
                                                </div>
                                            )
                                        }
                                        {
                                            msg.type === 'file' && (
                                                <div className="position-relative">
                                                    <Select
                                                        size="small"
                                                        className="w-100"
                                                        options={context.files.items.map(fl => ({ value: fl.name, label: fl.name }))}

                                                        value={msg.value}
                                                        onChange={(value) => {
                                                            let c_msgs = formik.values.messages;
                                                            let c_msg = {...c_msgs[i], value: value};
                                                            c_msgs[i] = c_msg;
                                                            formik.setFieldValue('messages', c_msgs);
                                                        }}
                                                    ></Select>

                                                    <button type="button" className="btn btn-sm p-0 position-absolute mx-1 top-0"
                                                        style={{ right: "-18px" }}
                                                        onClick={() => removeMessage(formik, msg.id)}
                                                    >
                                                        <i className="fas fa-xmark text-danger"></i>
                                                    </button>
                                                </div>
                                            )
                                        }
                                    </div>
                                ))
                            }

                            {/* <div className="mb-2">
                                <pre>
                                    <code>
                                        { JSON.stringify(formik.values.messages, null, 4) }
                                    </code>
                                </pre>
                            </div> */}

                            <div className="mb-2">
                                <div className="row gx-1">
                                    <div className="col"></div>
                                    <div className="col-auto text-end">
                                        <Button
                                            size="small"
                                            style={{ fontSize: '0.7em'}}
                                            type="primary"
                                            color="danger"
                                            htmlType="button"
                                            onClick={() => addMessage(formik, 'text')}
                                        >
                                            <i className="fas fa-plus me-2" style={{ fontSize: '0.9em' }} ></i>
                                            Agregar texto
                                        </Button>
                                    </div>
                                    <div className="col-auto text-end">
                                        <Button
                                            size="small"
                                            style={{ fontSize: '0.7em'}}
                                            type="primary"
                                            color="danger"
                                            htmlType="button"
                                            onClick={() => addMessage(formik, 'file')}
                                        >
                                            <i className="fas fa-plus me-2" style={{ fontSize: '0.9em' }} ></i>
                                            Agregar archivo / imagen
                                        </Button>
                                    </div>
                                </div>
                                <div>
                                    <ErrorMessage name='messages' component={FormBase.FormError} />
                                </div>
                            </div>

                            <div className="mb-2">
                                <div className="row">
                                    <div className="col">
                                        <button type="button" className="btn btn-sm btn-danger w-100"
                                            onClick={() => context.modalBase.close()}
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                                    <div className="col">
                                        <button type="submit" className="btn btn-sm btn-dark w-100"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? "Guardando..." : "Guardar"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </Form>
                )
            }

        </Formik>
    )

}
